// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3iFp3","header":"PatientQuestionnaire_header__3uM5i","info":"PatientQuestionnaire_info__3IqK9"};